import React from "react";
import { Link } from "react-router-dom";
import MapImage from "../../../helper/images/map.png";
import Location from "../Location";
import { getLocations } from '../../../api/user';
import { useQuery } from '@tanstack/react-query';
import { useSettings } from "../../../context/SettingsContext";
import { useTranslation } from "../../../hooks/useTranslation";
import { useAuth } from "../../../context/AuthContext";
import { localStorageAuthUserData } from "../../../helper/commanFunc";

const HeroSection = () => {
  const { settings } = useSettings()
    const { t } = useTranslation();

  const showHotels = settings?.showHotels
  const { data: locationsData } = useQuery({
    queryKey: ["locations", showHotels],
    queryFn: () => getLocations({ hotels: showHotels, restaurants: true }),
    keepPreviousData: true,
    // enabled: !!showHotels,
  });
  const locations = locationsData?.data?.data || []
 const { token } = useAuth();



  return (
    <>
      <div className="bg-[#FFF3EF] relative">
        <div className="">
          <div className="grid md:grid-cols-2 grid-cols-1">
            <div className="lg:py-[112px] px-5 md:py-[70px] py-8 md:max-w-[670px]  md:ml-auto ">
              <h1 className="text-[#18181B] xl:text-[40px] lg:text-[30px] text-[25px] font-semibold xl:leading-[47px] lg:leading-[50px] leading-9 xl:mb-[30px] md:mb-5 mb-3">
                {settings?.showHotels ? t("home").heroSection.titlewithHotels : t("home").heroSection.titlewithoutHotels}
              </h1>
              <p className="text-lg leading-7">
                {t("home").heroSection.description}
              </p>
              <div className="flex items-center gap-[25px] w-full mt-[30px]">
                <Link
                  to={token ? "/restaurantordering" : "/login"}
                  className="rounded-[2px] bg-[#4CAF50] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] 2xl:px-5 p-3 green-shadow hover:bg-[#209b25]"
                >
                  {t("home").heroSection.getStarted}
                </Link>
                <Link
                  to="/about"
                  className=" rounded-[2px] bg-[#FFA808] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] 2xl:px-5 p-3 yellow-shadow hover:bg-[#D69723]"
                >
                  {t("home").heroSection.learnMore}
                </Link>
              </div>
            </div>
            <div className="h-full">
              <Location data={locations}></Location>
              {/* <img
                src={MapImage}
                alt="map"
                className="w-full h-full object-cover"
              /> */}
            </div>


          </div>
          
        </div>
      </div>
    </>
  );
};

export default HeroSection;
